module.exports = __webpack_public_path__ + "img/addGroupImage.6e85ed10.svg";